import Loader from "./loader";
import config from "../constants/config";

const loader = new Loader();

export const getBasemapToggle = async (view) => {
  const {
    modules: [BasemapToggle],
  } = await loader.load(["esri/widgets/BasemapToggle"]);
  return new BasemapToggle({
    view,
    nextBasemap: "hybrid",
  });
};
